// extracted by mini-css-extract-plugin
export default {"list":"NoteExpertGeneralPageReasonsCarousel_list__sF9KN"};